export default __webpack_public_path__ + "static/media/infoIcon-26988d31bd444d804ee09b951263b3a9.png";